export default "__VITE_ASSET__Cp8zwkJJ__ 100w";